<app-saved-search-filters />

<app-facet-list
  [title]="'FACETS.STANDARD'"
  [expandFacets]="false"
  [expandOnlyFirstFacets]="true"
  [expandRoot]="true"
  [facets]="searchFacets"
  (selectFacet)="emitFacetFilter($event)"
>
</app-facet-list>

<app-facet-list
  [title]="'FACETS.ADVANCED'"
  [expandFacets]="false"
  [expandRoot]="false"
  [facets]="advancedSearchFacets"
  (selectFacet)="emitFacetFilter($event)"
>
</app-facet-list>

<app-facet-list
  [title]="'FACETS.SEMANTIC'"
  [expandFacets]="false"
  [expandRoot]="false"
  [facets]="searchFacetsSemantic"
  (selectFacet)="emitFacetFilter($event)"
>
</app-facet-list>
